export const TOOLBAR_PRESETS = {
  basic: [
    ['bold', 'italic', 'underline'],
    ['bulletList', 'orderedList'],
    ['undo', 'redo'],
  ],
  medium: [
    ['paragraph', 'heading1', 'heading2'],
    ['bold', 'italic', 'underline', 'code', 'blockquote', 'link'],
    ['bulletList', 'orderedList'],
    ['undo', 'redo'],
  ],
};

export const DEFAULT_AI_PROMPT_PLACEHOLDER = 'Make it more concise';
